export function isChristmas() {
  const date = new Date();
  return (
    date.getMonth() === 11 || (date.getMonth() === 0 && date.getDate() <= 6)
  );
}
